export var appconfig = {
    cust_serv_email: "contactus@continuitysubs.com",
    cust_serv_number: "1-855-624-4484",
    emailto: "mailto:",
    common_sys_err1:"Oops! Something Went Wrong.",
    common_sys_err2: "Please refresh the page or try again later",
    subsid_required: "Please enter a valid Subscription ID",
    email_required: "Please enter a valid Email address",
    message_required: "Please enter a Message",
    firstname_required: "Please enter your First Name",
    lastname_required: "Please enter your Last Name",
    reason_required: "Please select a valid Topic",
    cancel_reasons: [
        { id: '-1', desc:"Please Select"},
        { id:"General Inquiry", desc:"General Inquiry"},
        { id: "Cancel Membership", desc: "Cancel Subscription" }],
    search : {
        no_search_data: "We were unable to locate your order. Please contact Customer Service via phone at 1-855-624-4484 or via email at ",
        subsid_pattern: "^[a-zA-Z0-9]*$",
        email_pattern: "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$",
    },
    cancel: {
        cancel_conf_msg_1: "Thank You.",
        /*cancel_conf_msg_2 :"You order has been submitted for cancellation. You should receive an email within 48-72 hours confirming that your cancellation has been completed.", */
        cancel_conf_msg_2: "Your order has been submitted for cancellation. Your subscription will remain active until ",
        cancel_fail_msg_1: "We were unable to process your cancellation at this time. Please contact Customer Service via phone at 1-855-624-4484 or via email at",
        cancel_conf_msg:"Are you sure you want to cancel your subscription?"
    },
    custService: {
        cust_serv_conf_msg: "Thank You for your inquiry. You request has been submitted to Customer Service. Someone will reach out to you within 48-72 hours.",
        cust_serv_fail_msg_1: "We were unable to process your customer service request at this time. Please contact Customer Service via phone at 1-855-624-4484 or via email at",
        csa_message_length:"32000"
    },
    status: {
        active: "Active",
        cancelled: "Cancelled",
        cancel_inprogress: "Cancel in Progress",
        cancel_active_status: "initiate"
    },
    labels: {
        page_title: "Online Subscription Management",
        loading: "Loading",
        cancel_name: "Name:",
        cancel_email: "Email:",
        cancel_subsid: "Subscription ID:",
        cancel_signup_date: "Signup Date:",
        cancel_price: "Price:",
        cancel_subs_status: "Subscription Status:",
        cancel_next_billing_date: "Next Billing Date:",
        cancel_btn:"Cancel Subscription",
        cust_ser_btn: "Contact Customer Service",
        cust_ser_header1: "How can we help?",
        cust_ser_header2: "Submit your question using the form below, and we will respond within 48 hours.",
        email: "Email",
        subs_id: "Subscription ID",
        topic: "Topic",
        message: "Message",
        cust_serv_sub_btn: "Submit Case",
        contact_us: "Contact Us:",
        current_year: (new Date()).getFullYear(),
        copy_right: "Synapse Group, Inc.",
        privacy_policy: "Privacy Policy",
        privacy_policy_ca: "Your California Privacy Rights",
        header_brand: "ContinuitySubs",
        search_whats_this: "What's this?",
        email_add: "Email Address",
        search_btn: "Search",
        search_manage: "Manage subscriptions of our partners:",
        subs_id_plh: "ex. 39484939",
        email_plh : "example@email.com",
        firstName: "First Name",
        lastName: "Last Name",
        yes_btn:"Yes",
        no_btn:"No",
        conf_header:"Subscription Cancellation",
        customer_service: "Customer Service",
        foodnwine_title: "Food & Wine Connoisseur Club",
        golf_title: "Golf Players Club",
        skyguide_title: "SkyGuide Executive Privilege Club",
        elite_title: "Travel + Leisure Elite Traveler"
    }

}


// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/config/app-config.ts